import { Component } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss']
})
export class TimepickerComponent {
  @Output() getSelectedTime = new EventEmitter<string>();
  timeList: any=[];
  selectedTime: any;
  isOpen = false;
  isTimeSelected=false;
  ngOnInit(): void {

    this.renderTime();

  }
  renderTime() {
    for (let i = 1; i <= 12; i++) {
      for (let j = 0; j < 60; j += 15) {
        if (j === 0) {
          this.timeList.push(i + ':' + '00' + ' AM');
        }
        else {
          this.timeList.push(i + ':' + j + ' AM');
        }

      }
    }
    for (let i = 1; i <= 12; i++) {
      for (let j = 0; j < 60; j += 15) {
        if (j === 0) {
          this.timeList.push(i + ':' + '00' + ' PM');
        }
        else {
          this.timeList.push(i + ':' + j + ' PM');
        }

      }
    }

  }
  getTimeValue(time: any) {
    this.selectedTime = time;
    this.isOpen = false;
    this.isTimeSelected=true;
    this.getSelectedTime.emit(time)
  }

}
